import { render } from "./vBox_RA.vue?vue&type=template&id=4ae6038f&scoped=true"
import script from "./vBox_RA.vue?vue&type=script&lang=js"
export * from "./vBox_RA.vue?vue&type=script&lang=js"

import "./vBox_RA.vue?vue&type=style&index=0&id=4ae6038f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ae6038f"]])

export default __exports__